import React, { useCallback } from 'react'
import { UserInfo } from '@/types'
import { useNavigate } from 'react-router-dom'
import { Avatar, Stack, Link, List, ListItem, ListItemButton, ListItemText, ListItemIcon } from '@mui/material'
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import Icon from '@/components/Icon'
import { IdCard, IdIcon, Row, IdMenuButton } from './components'
import Text from '@/components/Text'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { Copy } from '@/icon'
import { logout } from '@/api'
import { NoticeIcon, AccountIcon } from '@/icon/menu'
import CounterBadge from '@/components/CounterBadge'
import { Badge, TagRow } from '@/components/Header/components'
import { OPT_LIST } from '@/components/Header/profilePanel'
import { Message } from '@cx/ui'
export interface UserPanelProps {
  userInfo: UserInfo
  unreadCount: number
  verified: boolean
}

const UserPanel: React.FC<UserPanelProps> = (props) => {
  const { userInfo, unreadCount, verified } = props
  const navigate = useNavigate()

  const toAccount = useCallback(() => {
    navigate('/console/personal')
  }, [navigate])

  const toNotification = useCallback(() => {
    navigate('/console/personal?tab=1')
  }, [navigate])

  const onCopy = useCallback(() => {
    Message.success('用户ID已复制到剪贴板')
  }, [])

  const toLink = (link: string) => () => {
    navigate(link)
  }
  const handleLogout = () => {
    logout().then(() => {
      window.open('/login', '_self')
    })
  }

  return (
    <IdCard>
      <Row sx={{ gap: '16px' }}>
        <Avatar
          src={userInfo?.head_img_url ?? userInfo?.nickname}
          sx={{ width: 40, cursor: 'pointer' }}
          onClick={toAccount}
        />
        <Stack>
          <Text
            size='xs'
            sx={{
              textOverflow: 'ellipsis',
              maxWidth: '10rem',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              fontWeight: 700,
              color: '#000',
            }}
            title={userInfo?.nickname}
          >
            {userInfo?.nickname}
          </Text>
          <Row sx={{ gap: '8px' }}>
            <Text
              size='xs'
              weight='thin'
              sx={{
                textOverflow: 'ellipsis',
                maxWidth: '10rem',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                color: 'rgba(0, 0, 0, 0.5)',
              }}
            >
              {userInfo?.id}
            </Text>

            <CopyToClipboard text={userInfo?.id?.toString() || ''} onCopy={onCopy}>
              <Icon
                type='icon-copy'
                sx={{
                  width: '12px',
                  color: 'primary.main',
                  cursor: 'pointer',
                }}
              />
            </CopyToClipboard>
          </Row>
        </Stack>
      </Row>
      <TagRow sx={{ ml: '56px' }}>
        <Badge state={verified ? 'success' : 'warning'}>
          {verified ? (
            <CheckCircleRoundedIcon sx={{ color: 'success.main', fontSize: 14, mr: 0.5 }} />
          ) : (
            <ErrorRoundedIcon sx={{ fontSize: 14, mr: 0.5 }} />
          )}
          {verified ? '已认证' : '未实名认证'}
        </Badge>
        {!verified && (
          <Link
            underline='none'
            sx={{
              display: 'flex',
              cursor: 'pointer',
              alignItems: 'center',
              color: 'primary.main',
              fontWeight: 400,
              fontSize: '12px',
            }}
            onClick={toLink('/console/personal')}
          >
            去认证
          </Link>
        )}
      </TagRow>
      <List sx={{ width: '100%', py: 0 }}>
        {OPT_LIST.map((item) => {
          return (
            <ListItem
              key={item.name}
              disablePadding
              sx={{
                height: 40,
                borderRadius: '4px',
                marginBottom: '4px',
                transition: 'background 0.3s',
                '&:hover': {
                  background: 'rgba(32,108,255,0.1)',
                },
              }}
            >
              <ListItemButton
                sx={{
                  '&:hover': {
                    background: 'transparent',
                  },
                }}
                onClick={() => {
                  navigate(item.link)
                }}
                dense
              >
                <ListItemIcon sx={{ minWidth: 34 }}>
                  <Icon type={item.icon} sx={{ fontSize: 16 }} />
                </ListItemIcon>
                <ListItemText sx={{ color: '#000' }} primary={item.name} />
              </ListItemButton>
            </ListItem>
          )
        })}
        <ListItem
          disablePadding
          sx={{
            height: 40,
            borderRadius: '4px',
            marginBottom: '4px',
            transition: 'background 0.3s',
            '&:hover': {
              background: 'rgba(246,78,84,0.06)',
            },
          }}
        >
          <ListItemButton
            onClick={handleLogout}
            dense
            sx={{
              '&:hover': {
                background: 'transparent',
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: 34 }}>
              <Icon type={'icon-tuichu'} sx={{ fontSize: 16, color: 'error.main' }} />
            </ListItemIcon>
            <ListItemText sx={{ color: 'error.main' }} primary='退出' />
          </ListItemButton>
        </ListItem>
      </List>
    </IdCard>
  )
}

export default UserPanel
